import { ClipboardPlus } from 'lucide-react';

import { buildMedicalSummary } from '~entities/student/lib/medical';
import type { Medical } from '~entities/student/modal/medical';

import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from '~shared/shadcn/ui/tooltip';

export interface MedicalBadgeWithTooltipProps {
  medical?: Medical;
}

export const MedicalBadgeWithTooltip = ({
  medical,
}: MedicalBadgeWithTooltipProps) => {
  if (!medical) {
    return null;
  }

  const summary = buildMedicalSummary(medical);

  if (summary.length === 0) {
    return null;
  }

  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <span
          className='inline-flex cursor-default items-center'
          aria-label='Has medical or allergy information'
        >
          <ClipboardPlus className='size-4 shrink-0 text-red-400' />
        </span>
      </TooltipTrigger>
      <TooltipContent
        side='top'
        className='max-w-xs space-y-1 bg-primary px-3 py-2 text-left text-primary-foreground'
      >
        {summary.map((item) => (
          <div key={item.label}>
            <span className='font-semibold'>{item.label}: </span>
            <span>{item.value}</span>
          </div>
        ))}
      </TooltipContent>
    </Tooltip>
  );
};
